export default {
  decorateGlobal: {
    globalConfig: '小程序全局配置',
    pageConfig: '页面导航配置',
    themeConfig: '主题设置',
    splashScreenConfig: '启动页配置',
    dialogConfig: '弹窗配置',
    shareConfig: '分享配置',
    tabBarConfig: '首页底部 Tab 配置',
    floatButtonConfig: '浮动按钮配置',
    pageNavigationConfig: '页面导航配置',
    pageTitle: '页面标题',
    navigationTitle: '导航标题',
    titleDisplay: '标题显示',
    titleColor: '标题颜色',
    navigationBar: '导航栏',
    navigationBarDisplay: '显示导航栏',
    display: '显示',
    hide: '隐藏',
    transparentNavigation: '透明导航',
    navigationBackgroundColor: '滑动后的导航栏背景颜色',
    navigationTextColor: '滑动后的导航栏文字颜色',
    navigationFixedTop: '导航固定顶部',
    backButton: '返回按钮',
    navigationImage: '图片',
    scrolledNavigationImage: '滑动后的图片',
    navigationImageHint: '图片建议尺寸为：110px × 40px 或同比例图片',
    imageWidth: '图片宽度',
    imageHeight: '图片高度',
    imageCentered: '图片居中',
    storeModeCenterHint: '门店模式建议居中显示。',
    leftDistance: '左边距',
    pageBackground: '页面背景',
    pageBackgroundHeight: '页面背景高度',
    themeColor: '主题颜色',
    themeTextColor: '主题文字颜色',
    themeColorHint: '页面中图标颜色、按钮背景色、选择框',
    themeTextColorHint: '按钮文字颜色',
    backgroundColorHint: '导航栏、模块背景色值',
    backgroundTextColor: '背景文字颜色',
    backgroundTextColorHint: '导航栏、模块背景色值文字的颜色（注意：避免文字颜色与背景色相同）',
    statusBarColor: '手机状态栏颜色',
    black: '黑色',
    white: '白色',
    otherSettings: '其他设置',
    multilingualSwitch: '多语言切换',
    isEnabled: '是否启用',
    enabled: '开启',
    disabled: '关闭',
    image: '图片',
    splashPage: '启动页',
    splashImageHint: '750px × 1623px 或同比例尺寸',
    dialogImageHint: '400px × 450px 或同比例尺寸',
    recommendedSize: '推荐尺寸',
    jumpLink: '跳转链接',
    clickToView: '点击查看',
    displaySeconds: '显示秒数',
    intervalHours: '间隔小时',
    hourUnit: '小时',
    secondUnit: '秒',
    pixelUnit: 'px',
    closePanel: '关闭',
    viewCode: '代码',
    resetConfig: '重置',
    configHelp: '配置帮助',
    shareIconDisplay: '分享图标显示',
    shareImage: '分享图片',
    shareTitle: '分享标题',
    shareDescription: '分享描述',
    shareIcon: '分享图标',
    shareIconHint: '推荐尺寸：26px × 26px 或同比例图片',
    defaultShareTitle: '分享我的好物',
    defaultShareDescription: '万物来袭，极限开黑，速来！',
    message: '消息',
    shoppingCart: '购物车',
    buttonSize: '按钮大小',
    rightDistance: '右边距',
    bottomDistance: '底部距离',
    openIcon: '展开图标',
    closeIcon: '收起图标',
    tabBarSettings: '首页底部 Tab 设置',
    customIcon: '自定义图标',
    no: '否',
    yes: '是',
    defaultIcon: '默认图标',
    iconNumber: '图标 {number}',
    tabIconHint: '80px × 80px 或同比例尺寸',
    icon: '图标',
    unselected: '未选中',
    selected: '选中',
    defaultColor: '默认颜色',
    selectedColor: '选中时颜色',
    unselectedIcon: '未选中图标',
    selectedIcon: '选中图标',
    addTabBarItem: '新增 Tab 项',
  },
};
